
package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
actual data class SignInParams(
    actual var account: String  = "",
    actual var password: String  = "",

)
